module.exports = __webpack_public_path__ + "media/images/new/icons/phone-2597176e7428121db0937a63c3648488.png";